export const PaymentLinkMode = {
  NEVER: 0,
  FIRST_TIME_ONLY: 1,
  ALWAYS: 2,
  ONLINE_ONLY: 3,
  FIRST_TIME_OR_ONLINE: 4,
} as const;

export const canOfferPaymentLinkBeforePatientLookup = ({
  mode,
  online,
}: {
  mode: number;
  online: boolean;
}): boolean => {
  switch (mode) {
    case PaymentLinkMode.FIRST_TIME_ONLY:
    case PaymentLinkMode.ALWAYS:
    case PaymentLinkMode.FIRST_TIME_OR_ONLINE:
      return true;
    case PaymentLinkMode.ONLINE_ONLY:
      return online;
    case PaymentLinkMode.NEVER:
    default:
      return false;
  }
};

/**
 * Mirrors `server/lib/paymentLinkPolicy.ts#resolveReservationExpiryMinutes`:
 * the value keeps its sign (negative = N minutes before the visit start) and
 * only `0` falls back to the public setting. Keep both in sync.
 */
export const getEffectivePublicReservationExpiryMinutes = ({
  mode,
  online,
  publicReservationExpiryMinutes,
  onlineReservationExpiryMinutes,
}: {
  mode: number;
  online: boolean;
  publicReservationExpiryMinutes: number;
  onlineReservationExpiryMinutes: number;
}): number => {
  const onlineExpiryModes: number[] = [
    PaymentLinkMode.ALWAYS,
    PaymentLinkMode.ONLINE_ONLY,
    PaymentLinkMode.FIRST_TIME_OR_ONLINE,
  ];
  const supportsOnlineExpiry = online && onlineExpiryModes.includes(mode);

  if (supportsOnlineExpiry && onlineReservationExpiryMinutes !== 0) {
    return onlineReservationExpiryMinutes;
  }

  return publicReservationExpiryMinutes;
};
